import BasicPillar from './BasicPillar.jsx'

/**
 * Team & Culture pillar.
 *
 * 7 goals spanning hiring, onboarding, and internal culture
 * initiatives. May use section dividers for grouping.
 */
export default function TeamPillar() {
  return (
    <BasicPillar
      pillarId="team"
      description={
        'Q2 2026 team + culture goals: hiring, onboarding, and internal initiatives.'
      }
    />
  )
}
